import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserHistory } from 'history';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import setupSentry from './setupSentry';

// To disable react devtools in production
if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}

const history = createBrowserHistory();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
setupSentry(history as any);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
